import moment from 'moment'
import * as api from '@/modules/calendar/api'
import {ActionTree} from 'vuex'
import {CalendarState} from '@/modules/calendar/store/index'
import {RootState} from '@/store/types'
import {MutationTypes} from '@/modules/calendar/store/mutations';
import CalendarEvent from '@/modules/calendar/model/CalendarEvent';
import CalendarEventType from '@/modules/calendar/model/CalendarEventType';

const actions: ActionTree<CalendarState, RootState> = {
    /**
     * Carga todos los eventos registrados en el calendario
     *
     * @param state
     */
   async loadCalendarEvents ({state, commit, dispatch}) {

       // Carga la lista de tipos de eventos
       await dispatch('loadCalendarEventTypeList')

       // La lista ya se ha obtenido, no se vuelve a solicitar al servidor
       if (state.calendarEvents.length > 0) {
           return
       }

       commit(MutationTypes.SetCalendarEvents, await api.listEvents())
   },

    /**
     * Crea nuevo evento de calendario en el estado de la aplicación y los establece
     * como evento actualmente en edición por el usuario
     *
     * @param commit
     */
    async createNewEvent ({commit}) {
        commit(MutationTypes.SetCurrentCalendarEvent, new CalendarEvent())
        commit(MutationTypes.ToggleCreatingCalendarEvent, true)
    },

    /**
     * Carga la lista de tipos de eventos en el estado de la aplicación
     */
    async loadCalendarEventTypeList ({commit, state}) {
        // Ya se ha obtenido la lista de tipos de eventos
        if (state.calendarEventTypes.length > 0) {
            return
        }

        commit(MutationTypes.SetCalendarEventTypeList, await api.getCalendarEventTypeList())
    },

    /**
     * Guarda un evento de calendario en la API
     */
    async saveCalendarEvent ({state, commit}) {
        let event = state.currentCalendarEvent

        event = event.isNew
            ? await api.createCalendarEvent(event)
            : await api.updateCalendarEvent(event)

        commit(MutationTypes.SetCurrentCalendarEvent, event)
        commit(MutationTypes.AddCalendarEvent, event)
    },

    /**
     * Elimina un evento de calendario
     *
     * @param state
     * @param commit
     */
    async deleteCalendarEvent ({state, commit}) {
        const id = await api.deleteCalendarEvent(state.currentCalendarEvent)

        // Elimina el evento de la lista y también del evento actual
        commit(MutationTypes.RemoveCalendarEvent, id)
        commit(MutationTypes.SetCurrentCalendarEvent, new CalendarEvent())
    },

    /**
     * Registra en el servidor los cambios realizados sobre el tipo de evento de calendario
     * actualmente en edición por el usuario
     */
    async saveCalendarEventType ({state, commit}) {
        const isNew = state.currentCalendarEventType.isNew
        let type = state.currentCalendarEventType
        type = type.isNew
            ? await api.createCalendarEventType(type)
            : await api.updateCalendarEventType(type)

        commit(MutationTypes.SetCurrentCalendarEventType, type)
        commit(MutationTypes.AddCalendarEventType, type)
    },

    /**
     * Elimina el tipo de evento de calendario actualmente en edición por el usuario
     *
     * @param state
     * @param commit
     */
    async deleteCalendarEventType ({state, commit}) {
        const id = state.currentCalendarEventType.id
        await api.deleteCalendarEventType(state.currentCalendarEventType)

        commit(MutationTypes.SetCurrentCalendarEventType, new CalendarEventType())
        commit(MutationTypes.DeleteCalendarEventType, id)
    },
}

export default actions
